import { Component, OnInit,EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import { NotificationService } from '../notification.service';
import { FormBuilder, Validators , FormGroup} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-reason-create',
  templateUrl: './reason-create.component.html',
  styleUrls: ['./reason-create.component.scss']
})
export class ReasonCreateComponent implements OnInit {
  SelectedValue:any;
  Reasonvalue: any;
  Submitted: boolean=false;
  creatCustomer: FormGroup 
  reasonby:any;
  ChangeList(e){
    this.SelectedValue=e.target.value
  }
  isDeleted1 = new EventEmitter()
  reason:any;
  constructor(public dialog: MatDialog,private fb: FormBuilder,private notification:NotificationService,private service:CommonService,private snack:MatSnackBar,private router: Router,private dialogRef: MatDialogRef<ReasonCreateComponent>) { }

  ngOnInit(): void {


    this.creatCustomer = this.fb.group(
      {
        reasonfor: ['', [Validators.required]],
         
          reason: ['', [Validators.required]],
         

          }
    )
  }
  closeDialog() {
    this.dialogRef.close();
  }
  sendit(inputValue1){
    this.Reasonvalue=inputValue1;
  }
  get f() {
    return this.creatCustomer?.controls;
  }
  createreason(valid){
    this.reason =this.Reasonvalue
    this.reasonby=this.SelectedValue;


    this.Submitted = true
    this.creatCustomer?.markAllAsTouched()
    if(valid){
      let req ={
        "reason": this.reason
        }
      this.service.reasoncreate(this.reasonby,req).subscribe((data : any)=> {

        if(data.message == "Success"){
          this.notification.showSuccess("created successfully",'')
          this.isDeleted1.emit(true)
          this.dialogRef.close();
        }else{
        }
    })
    }
}
reset(){
  this.creatCustomer?.reset()
}
}
